'use client'

import { memo, useEffect, useState } from 'react'

type InkflowPastePhase = 'idle' | 'recording' | 'processing' | 'pasting' | 'done'

type NinxlInkflowPasteDemoProps = {
  phase: InkflowPastePhase
}

const PREFIX = 'Dear team,'
const PASTE_TEXT = " let's sync on the Q3 roadmap before Friday."

/** baby: Simulates text landing at the cursor after InkFlow transcribes. */
export const NinxlInkflowPasteDemo = memo(function NinxlInkflowPasteDemo({
  phase,
}: NinxlInkflowPasteDemoProps) {
  const [typedLength, setTypedLength] = useState(0)

  useEffect(() => {
    if (phase === 'idle') {
      setTypedLength(0)
      return undefined
    }

    if (phase !== 'pasting') {
      return undefined
    }

    setTypedLength(0)
    let cancelled = false
    let index = 0

    const tick = () => {
      if (cancelled) return
      index += 1
      setTypedLength(index)
      if (index < PASTE_TEXT.length) {
        window.setTimeout(tick, 38)
      }
    }

    tick()

    return () => {
      cancelled = true
    }
  }, [phase])

  const pastedText =
    phase === 'done'
      ? PASTE_TEXT
      : phase === 'pasting'
        ? PASTE_TEXT.slice(0, typedLength)
        : ''

  return (
    <div className="ninxl-inkflow-paste-demo">
      <p className="ninxl-inkflow-paste-line">
        <span>{PREFIX}</span>
        {pastedText ? <span>{pastedText}</span> : null}
        <span
          className="ninxl-inkflow-paste-cursor"
          aria-hidden
          data-active={phase === 'recording' || phase === 'processing' || phase === 'pasting' ? 'true' : 'false'}
        />
      </p>
      <span className="ninxl-inkflow-paste-app">Notes · anywhere on your Mac</span>
    </div>
  )
})

export { PREFIX as INKFLOW_PASTE_PREFIX, PASTE_TEXT as INKFLOW_PASTE_TEXT }
